import api from "@/helpers/api-rest/api.js";

const BASE = "/api/v1/media";

export default {
  list(params = {}) {
    return api.get({ url: BASE, params });
  },

  get(id) {
    return api.get({ url: `${BASE}/${id}` });
  },

  upload(file, { onProgress, withLoading = false } = {}) {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: onProgress,
    };

    return api.post({
      url: BASE,
      data: formData,
      config,
      withLoading,
    });
  },

  update(id, data) {
    return api.patch({ url: `${BASE}/${id}`, data });
  },

  replaceFile(id, file, { onProgress, withLoading = false } = {}) {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: onProgress,
    };

    return api.post({
      url: `${BASE}/${id}/replace-file`,
      data: formData,
      config,
      withLoading,
    });
  },

  delete(id) {
    return api.delete({ url: `${BASE}/${id}` });
  },
};
